import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

type ThankYouModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  /** Supports multiple lines via "\n". */
  message?: string;
};

const ThankYouModal: React.FC<ThankYouModalProps> = ({
  isOpen,
  onClose,
  title = "Thank you",
  message = "Your message has been sent.\nWe will reply within 24 hours.",
}) => {
  return (
    // z-[60] keeps this above the contact form (z-50) it opens from.
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-[60] overflow-y-auto" onClose={onClose}>
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
          </Transition.Child>

          <span className="inline-block h-screen align-middle" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div
              className="inline-flex flex-col items-center w-full max-w-sm px-8 py-10 text-center align-middle transition-all transform bg-white shadow-xl"
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              {/* Gold badge with check */}
              <div
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  background: "#B88333",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 13l4 4L19 7"
                    stroke="#ffffff"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <Dialog.Title as="h3" className="mt-5 text-[20px] font-semibold text-[#01152E]">
                {title}
              </Dialog.Title>
              <p className="mt-2 text-[14px] leading-[22px] text-[#445162] whitespace-pre-line">
                {message}
              </p>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ThankYouModal;
